module.exports = __webpack_public_path__ + "static/media/nerito-marketing-wave.e0daf9d7.svg";